import React, { useEffect, useState } from 'react';
import Form from '@rjsf/core';
import validator from '@rjsf/validator-ajv8';

const functionNames = [
    'get_current_date', 'get_from_response', 'get_score', 'get_unique_matching_responses', 'get_pairwise_comparison_string_option'
];

const functionDescription = {
    get_current_date: 'get the current date; 1 arg; date',
    get_from_response: 'get variable from response; 1 arg; step number from wherer to fetch',
    get_unique_matching_responses: 'get all the unique matching responses; 0 arg',
    get_score: 'scoring_method : string , options: [Consensus,  Right answer] the right answer : string , (if consensus then none) points_rewarded_correct : integer points_rewarded_wrong : integer',
    get_pairwise_comparison_string_option: 'Arguments required: Arg 0 = dataset instance name, Arg 1 = maximum amount of comparisons for user, Arg 2 = 1 or 2 (to return comparison object 1 or 2)riner',
}

const initialFormData = {
    restart_word: 'restart',
    survey: {
        start: {
            type: 'var',
            msgs: ['Hi! This is the start of the survey'],
            next: 'start'
        },
    }
};

const uiSchema = {
    "ui:globalOptions": {
        enableMarkdownInDescription: true,
        orderable: false,
    },
    "ui:submitButtonOptions": {
        submitText: "Generate JSON",
        norender: false,
    }
};

const baseSchema = {
    title: 'NOKi Form',
    type: 'object',
    required: ['restart_word'],
    properties: {
        restart_word: { type: 'string', title: 'Restart Message', description: 'This message will restart this survey process.' },
        survey: {
            type: 'object',
            title: 'Survey Questions',
            description: "Configure the survey questions with various types and messages.",
            additionalProperties: {
                type: 'object',
                properties: {
                    type: {
                        type: 'string',
                        title: 'Question Type',
                        description: 'Choose the type of question you want to ask.',
                        enum: ['var', 'text', 'mcq'],
                    },
                    next: {
                        type: 'string',
                        title: 'Next Question',
                        enum: [''] // To be updated dynamically
                    }
                },
                allOf: [
                    {
                        if: {
                            properties: { type: { const: "var" } }
                        },
                        then: {
                            properties: {
                                msgs: {
                                    type: 'array',
                                    title: 'Message',
                                    items: { type: 'string' }
                                },
                                params: {
                                    type: 'object',
                                    title: 'Message Variable',
                                    additionalProperties: {
                                        type: 'object',
                                        properties: {
                                            function_name: {
                                                type: 'string',
                                                enum: functionNames,
                                                title: 'Function Name'
                                            },
                                            args: {
                                                type: 'array',
                                                items: {
                                                    oneOf: [
                                                        {
                                                            type: 'string',
                                                            title: 'String Value',
                                                            pattern: '^[a-zA-Z0-9_]*$'
                                                        },
                                                        {
                                                            type: 'integer',
                                                            title: 'Integer Value',
                                                            pattern: '^[0-9]*$'
                                                        }
                                                    ]
                                                }
                                            }
                                        },
                                        allOf: [
                                            {
                                                if: { properties: { function_name: { const: 'get_current_date' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_current_date
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_from_response' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_from_response
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_score' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_score
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_pairwise_comparison_string_option' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_pairwise_comparison_string_option
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_unique_matching_responses' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_unique_matching_responses
                                                        }
                                                    }
                                                }
                                            },
                                        ]
                                    }
                                }
                            }
                        }
                    },
                    {
                        if: {
                            properties: { type: { const: "text" } }
                        },
                        then: {
                            properties: {
                                msgs: {
                                    type: 'array',
                                    title: 'Message',
                                    items: { type: 'string' }
                                },
                                params: {
                                    type: 'object',
                                    title: 'Message Variable',
                                    additionalProperties: {
                                        type: 'object',
                                        properties: {
                                            function_name: {
                                                type: 'string',
                                                enum: functionNames,
                                                title: 'Function Name'
                                            },
                                            args: {
                                                type: 'array',
                                                items: {
                                                    oneOf: [
                                                        {
                                                            type: 'string',
                                                            title: 'String Value',
                                                            pattern: '^[a-zA-Z0-9]*$'
                                                        },
                                                        {
                                                            type: 'integer',
                                                            title: 'Integer Value',
                                                            pattern: '^[0-9]*$'
                                                        }
                                                    ]
                                                }
                                            }
                                        },
                                        allOf: [
                                            {
                                                if: { properties: { function_name: { const: 'get_current_date' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_current_date
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_from_response' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_from_response
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_score' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_score
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_pairwise_comparison_string_option' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_pairwise_comparison_string_option
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_unique_matching_responses' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_unique_matching_responses
                                                        }
                                                    }
                                                }
                                            },
                                        ]
                                    }
                                }
                            }
                        }
                    },
                    {
                        if: {
                            properties: { type: { const: "mcq" } }
                        },
                        then: {
                            properties: {
                                msgs: {
                                    type: 'array',
                                    title: 'Message',
                                    items: { type: 'string' }
                                },
                                params: {
                                    type: 'object',
                                    title: 'Message Variable',
                                    additionalProperties: {
                                        type: 'object',
                                        properties: {
                                            function_name: {
                                                type: 'string',
                                                enum: functionNames,
                                                title: 'Function Name'
                                            },
                                            args: {
                                                type: 'array',
                                                items: {
                                                    oneOf: [
                                                        {
                                                            type: 'string',
                                                            title: 'String Value',
                                                            pattern: '^[a-zA-Z0-9]*$'
                                                        },
                                                        {
                                                            type: 'integer',
                                                            title: 'Integer Value',
                                                            pattern: '^[0-9]*$'
                                                        }
                                                    ]
                                                }
                                            }
                                        },
                                        allOf: [
                                            {
                                                if: { properties: { function_name: { const: 'get_current_date' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_current_date
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_from_response' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_from_response
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_score' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_score
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_pairwise_comparison_string_option' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_pairwise_comparison_string_option
                                                        }
                                                    }
                                                }
                                            },
                                            {
                                                if: { properties: { function_name: { const: 'get_unique_matching_responses' } } },
                                                then: {
                                                    properties: {
                                                        function_name: {
                                                            description: functionDescription.get_unique_matching_responses
                                                        }
                                                    }
                                                }
                                            },
                                        ]
                                    }
                                },
                                options: {
                                    type: "object",
                                    title: 'MCQ Options',
                                    additionalProperties: {
                                        type: "string"
                                    }
                                }
                            }
                        }
                    }
                ]
            }
        }
    }
};

const App = () => {
    const [formData, setFormData] = useState(initialFormData);
    const [submittedData, setSubmittedData] = useState(null);
    const [dynamicSchema, setDynamicSchema] = useState(baseSchema);

    const handleSubmit = ({ formData }) => {
        console.log('submitted', formData);

        // Helper function to recursively ensure "args" is always present
        const ensureArgsInParams = (obj) => {
            if (typeof obj !== 'object' || obj === null) return;

            for (const key in obj) {
                if (key === 'params' && typeof obj[key] === 'object') {
                    for (const paramKey in obj[key]) {
                        if (obj[key][paramKey].function_name && !('args' in obj[key][paramKey])) {
                            obj[key][paramKey].args = []; // Add default empty array for "args"
                        }
                    }
                } else if (typeof obj[key] === 'object') {
                    ensureArgsInParams(obj[key]); // Recursive check for nested objects
                }
            }
        };

        // Process the formData to ensure args is always present
        ensureArgsInParams(formData);

        const reorderedFormData = {
            restart_word: formData.restart_word,
            ...Object.fromEntries(
                Object.entries(formData).filter(([key]) => key !== "restart_word")
            )
        };

        console.log('submitted', reorderedFormData);

        setSubmittedData(reorderedFormData)
    };

    const extractKeysFromSurvey = (survey) => {
        return Object.keys(survey);
    };

    const generateDynamicSchema = () => {
        const surveyKeys = extractKeysFromSurvey(formData.survey);
        
        // Ensure enum properties are non-empty arrays or handle empty cases
        const nextEnum = surveyKeys.length ? surveyKeys : ['']; // Default empty value to prevent schema errors

        return {
            ...baseSchema,
            properties: {
                ...baseSchema.properties,
                survey: {
                    ...baseSchema.properties.survey,
                    additionalProperties: {
                        ...baseSchema.properties.survey.additionalProperties,
                        properties: {
                            ...baseSchema.properties.survey.additionalProperties.properties,
                            next: {
                                type: 'string',
                                title: 'Next Question',
                                enum: nextEnum
                            }
                        }
                    }
                }
            }
        };
    };

    useEffect(() => {
        setDynamicSchema(generateDynamicSchema());
    }, [formData]);

    const handleChange = ({ formData }) => {
        setFormData(formData);
    };

    const handleCopytoClipboard = () => {
        navigator.clipboard.writeText(JSON.stringify(submittedData, null, 2));
        alert('Copied to clipboard!');
    }

    return (
        <div className='form-container'>
            <div className='note'>
                <b>NOTE:</b> Please ensure that the survey questions form below begins with the key labeled "start" and ends with the key labeled "end".
            </div>
            <Form
                schema={dynamicSchema}
                formData={formData}
                validator={validator}
                onChange={handleChange}
                onSubmit={handleSubmit}
                onError={console.log.bind(console, 'errors')}
                uiSchema={uiSchema}
            />
            {submittedData && (
                <div>
                    <h3>Submitted Data:</h3>
                    <pre>{JSON.stringify(submittedData, null, 2)}</pre>

                    <button onClick={handleCopytoClipboard}>
                        Copy
                    </button>

                </div>
            )}
        </div>
    );
}

export default App;
